import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=631e9a4b&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=631e9a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e9a4b",
  null
  
)

export default component.exports